import React from 'react';
import { svg } from 'lib/svgList';
import NavAccordion from 'components/NavAccordion';
import { useSelector } from 'react-redux';
import OptionsMeasure from './OptionsMeasure';

export default function DataPersonal() {
	const { list, loadingRead } = useSelector((state) => state.measure);

	const filterByType = (type) => list.filter((item) => item.type === type);

	const data = [
		{
			id: 1,
			title: 'Medidas',
			subTitle: 'Área',
			icon: svg.icon.warningOrange,
			size: filterByType('area').length,
			content: <OptionsMeasure type="area" listDataUsers={filterByType('area')} loadingRead={loadingRead} />
		},
		{
			id: 2,
			title: 'Medidas',
			subTitle: 'Distância',
			icon: svg.icon.mapLocationOrange,
			size: filterByType('distance').length,
			content: <OptionsMeasure type="distance" listDataUsers={filterByType('distance')} loadingRead={loadingRead} />
		}
	];

	return <NavAccordion title="MEDIDAS" dataRouteMenu={data} isInitiOpen />;
}
